// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__wbeo1","languageSwitcher":"styles_languageSwitcher__B_xSR","dropdownList":"styles_dropdownList__5c0Jh","dropdownItem":"styles_dropdownItem__vAHew"};